export default "__VITE_ASSET__BGDJeGOh__"